import { date } from 'quasar'
import { distanceInWords } from 'src/utils/date'
import i18n from 'src/i18n/i18n'
import parseDate from 'date-fns/parse'

const getStatusText = invoice => {
  switch (invoice.status) {
  case 'open':
  case 'overdue':
  case 'partial':
    return getStatusTextDue(invoice)
  case 'paid':
  case 'paid_cash_discount':
    return getStatusTextPaid(invoice)
  }
}

const getStatusTextDue = invoice => {
  if (!invoice.due_date) {
    return ''
  }

  if (date.isSameDate(Date.now(), parseDate(invoice.due_date.date), 'day')) {
    return i18n.t('due_in', { dueIn: i18n.t('today') })
  }

  return i18n.t('due_in', {
    dueIn: distanceInWords(invoice.due_date.date)
  })
}

const getStatusTextPaid = (invoice) => {
  if (!invoice.last_payment_at) {
    return ''
  }

  return i18n.t('paid_on', {
    paidOn: distanceInWords(invoice.last_payment_at.date)
  })
}

export { getStatusText }
